/* Entry point: styles, first paint, service worker. */

import "./style.css";
import { render } from "./ui/app.js";
import { primeVoices } from "./core/tts.js";
import { alertDialog } from "./ui/modal.js";

/* Ask for the voice list early so the first Hören question isn't the one that
   discovers it's empty. Harmless where speech isn't supported. */
primeVoices();

render();

/* ---------- service worker ---------- */

registerSW({
  onUpdateReady(apply) {
    /* Deliberately not automatic: swapping assets under a running page could
       interrupt a game mid-round. Ask, then apply. */
    showUpdateBanner(apply);
  },
});

function registerSW({ onUpdateReady } = {}) {
  if (!("serviceWorker" in navigator)) return;
  if (location.protocol !== "https:" && location.hostname !== "localhost") return;
  /* Capacitor serves from capacitor:// or http://localhost inside a WebView,
     where the native app is already offline-capable. No SW needed there. */
  if (window.Capacitor?.isNativePlatform?.()) return;

  window.addEventListener("load", async () => {
    try {
      const reg = await navigator.serviceWorker.register("/sw.js", { scope: "/" });
      if (reg.waiting) onUpdateReady?.(() => activate(reg));
      reg.addEventListener("updatefound", () => {
        const sw = reg.installing;
        if (!sw) return;
        sw.addEventListener("statechange", () => {
          if (sw.state === "installed" && navigator.serviceWorker.controller) {
            onUpdateReady?.(() => activate(reg));
          }
        });
      });
    } catch (e) {
      console.warn("[sw] registration failed", e);
    }
  });

  let reloading = false;
  navigator.serviceWorker.addEventListener("controllerchange", () => {
    if (reloading) return;
    reloading = true;
    location.reload();
  });
}

function activate(reg) {
  reg.waiting?.postMessage({ type: "SKIP_WAITING" });
}

function showUpdateBanner(apply) {
  const bar = document.createElement("div");
  bar.className = "updatebar";
  bar.innerHTML = `<span>A new version is ready.</span><button>Update</button>`;
  bar.querySelector("button").onclick = () => {
    bar.remove();
    apply();
  };
  document.body.appendChild(bar);
}
